<template>
  <el-card shadow="never">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item
          v-if="$root.state.facility"
          :to="{ name: 'Facility Payments' }"
        >
          {{String($root.state.facilityData.code).toUpperCase()}} Payments
        </el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ name: 'Facility Payments Transaction'}"
        >
          {{  id  }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-card shadow="never" v-loading="loading">
      <template>
        Transaction Details
      </template>
      <el-descriptions border size="medium" direction="vertical">
        <el-descriptions-item label="Id">
          <el-tag>
            {{ transaction.id }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="Customer">
          {{  transaction.customer.company || transaction.customer.fullName }}
        </el-descriptions-item>
        <el-descriptions-item label="Status">
          <el-tag v-if="!transaction.success" :type="transaction.events[transaction.events.length - 1].status.toUpperCase() === 'FAILED' ? 'danger' : 'warning' ">
            {{ transaction.events[transaction.events.length - 1].status.toUpperCase() }}
          </el-tag>
          <el-tag v-else type="success">
            {{ transaction.events[transaction.events.length - 1].status.toUpperCase() }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="Type">
          {{ transaction.type }}
        </el-descriptions-item>
        <el-descriptions-item label="Created At">
          {{ transaction.createdAt | formatDate }}
        </el-descriptions-item>
        <el-descriptions-item label="Amount">
          {{ transaction.amount | currencySign }}
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <br/>
    <el-card shadow="never" v-loading="loading">
      <template slot="header">
        Wallet Transactions
      </template>
      <el-table :data="walletTransactions">
        <el-table-column
          label="Id"
          prop="id"
        ></el-table-column>
        <el-table-column
          label="Amount In Use"
          prop="amount"
          :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
        >
        </el-table-column>
        <el-table-column
          label="Created at"
          prop="createdAt"
          :formatter="(row, column, cellValue ) => $options.filters.formatDate(cellValue, this.$root.state.facilityData)"
        >
        </el-table-column>
        <el-table-column label="Details" prop="details">
        </el-table-column>
        <el-table-column label="Document">
          <template slot-scope="scope">
            <el-button
               v-if="scope.row.url"
               size="small"
               type="primary"
               icon="el-icon-view"
               @click="() => openPreview(scope.row.url)"
             >
             </el-button>
             <a
               v-if="scope.row.url"
               :href="scope.row.url"
               download
             >
              <el-button
                size="small"
                type="secondary"
                icon="el-icon-download"
              ></el-button>
             </a>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <br/>
    <el-card shadow="never" v-loading="loading">
      <template slot="header">
        Refund Transactions
      </template>
      <el-table :data="refundTransactions">
        <el-table-column
          label="Id"
          prop="ref.id"
        ></el-table-column>
        <el-table-column
          label="Amount Refunded"
          prop="amount"
          :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
        >
        </el-table-column>
        <el-table-column
          label="Created at"
          prop="createdAt"
          :formatter="(row, column, cellValue ) => $options.filters.formatDate(cellValue, this.$root.state.facilityData)"
        >
        </el-table-column>
        <el-table-column
          label="Created By"
          prop="createdBy"
        >
        </el-table-column>
        <el-table-column label="Reason" prop="ref.reason">
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog title="Receipt" :visible.sync="dialogForPdf">
      <PreviewPdf v-if="selectedDocument" :source="selectedDocument" />
    </el-dialog>
  </el-card>
</template>

<script>
import axios from 'axios';
import PreviewPdf from './PreviewPdf';
import { FACILITY_TRANSACTIONS_API_BASE, WALLET_TRANSACTIONS_API_BASE, REFUND_REQUEST_API_BASE } from '../env';

export default {
  name: 'FacilityTransaction',
  props: {
    id: { type: String, required: true },
    facility: { type: String, required: true },
  },
  components: { PreviewPdf },
  data() {
    return {
      transaction: null,
      walletTransactions: [],
      refundTransactions: [],
      receipts: [],
      selectedDocument: null,
      dialogForPdf: false,
      loading: false,
    };
  },
  async mounted() {
    this.loading = true;
    await this.getTransactionByShortId();
    await Promise.all([
      this.getWalletTransaction(),
      this.getRefundTransaction(),
    ]);
    this.loading = false;
  },
  methods: {
    openPreview(url) {
      this.selectedDocument = url;
      this.dialogForPdf = true;
    },
    async getTransactionByShortId() {
      const transactionResponse = await axios.get(`${FACILITY_TRANSACTIONS_API_BASE}/v1/transaction/${this.id}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.transaction = transactionResponse.data;
    },
    async getWalletTransaction() {
      const response = await axios.get(`${WALLET_TRANSACTIONS_API_BASE}/v1/${this.facility}/${this.transaction.customer._id}/${this.transaction._id}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      await this.getReceiptsByTransaction();
      response.data.forEach((item) => {
        const [doc] = this.receipts.filter((receipt) => receipt.walletTransaction === item._id );
        if (doc) {
          item.url = doc.url;
        }
      });

      this.walletTransactions = response.data;
    },
    async getRefundTransaction() {
      const response = await axios.get(`${REFUND_REQUEST_API_BASE}/v1/${this.facility}/${this.transaction.customer._id}/${this.transaction._id}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      // await this.getReceiptsByTransaction();
      response.data.forEach((item) => {
        const [doc] = this.receipts.filter((receipt) => receipt.walletTransaction === item.parent );
        if (doc) {
          item.url = doc.url;
        }
      });

      this.refundTransactions = response.data;
    },
    async getReceiptsByTransaction() {
      const response = await axios.get(`${WALLET_TRANSACTIONS_API_BASE}/v1/receipts/${this.facility}/${this.transaction.customer._id}/${this.transaction._id}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.receipts = response.data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FacilityTransaction.vue